import styled from 'styled-components';

interface ButtonStyledProps {
  fullWidth: boolean;
}

const ButtonStyled = styled.button<ButtonStyledProps>`
  border-radius: 8px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  padding: 10px;
  text-transform: ${({ theme }) => theme.btnTextTransform};
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-out;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};

  &:disabled {
    cursor: no-drop;
    opacity: 0.5;
  }

  &.primary {
    color: ${({ theme }) => theme.white};
    border: 1px solid ${({ theme }) => theme.primaryColor};
    background-color: ${({ theme }) => theme.primaryColor};
  }

  &.secondary {
    color: ${({ theme }) => theme.buttonPrimaryColor};
    border: 1px solid ${({ theme }) => theme.buttonPrimaryColor};
    background-color: transparent;
  }

  &.text {
    font-weight: normal;
    background-color: transparent;
    color: ${({ theme }) => theme.buttonPrimaryColor};
    border: none;
  }
`;

const Loading = styled.div`
  align-items: center;

  &:after {
    content: '';
    border-width: 4px;
    border: 2px solid #eee;
    animation: rotate 500ms infinite linear;
    border-right-color: transparent;
    border-top-color: transparent;
    border-radius: 100%;
    display: block;
    height: 20px;
    width: 20px;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default ButtonStyled;
export { Loading, ButtonStyled };
